<template>
    <footer id="footer" class="footer">
        <div class="btns">
            <a class="btn-logo-custom kikkoman_click" href="https://www.domohornwrinkle.com.tw/" target="_blank" rel="noreferrer noopener"></a>
            <div class="logo-box">
                <a class="btn-ig IG_click" href="https://www.instagram.com/domohorn_wrinkle_tw/" target="_blank" rel="noreferrer noopener"></a>
                <a class="btn-line Line_click" href="https://lin.ee/Hd1igrt" target="_blank" rel="noreferrer noopener"></a>
                <a class="btn-facebook Fb_click" href="https://www.facebook.com/DomohornWrinkle.tw/" target="_blank" rel="noreferrer noopener"></a>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: "FooterComponent",
};
</script>